import React from "react";
import { Container, Card, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

const reportCategories = [
  {
    title: "Employment Reports",
    reports: [
      "Time And Attendance",
      "Expirations",
      "Incident Accident Registry",
      //   "Assigned Equipment & Cards",
      //   "Incidents & Corrective Actions",
    ],
  },
  {
    title: "Recruitment Reports",
    reports: [
      //   "Applicant Conversion",
      "Associate Turnover",
      //   "Annual Hiring Efficiency",
      "Hiring Cycle",
      "Hiring Cycle Data",
      "Position History",
      //   "Ad Spend",
      //   "Referral Sources",
      //   "Referred By",
      //   "Number Of Applications by Recruiter",
      //   "Number Of SMS Notifications Sent",
      "Termination",
      "Document Status",
      "Contact List",
      //   "Service Center List",
      //   "Applicant Metrics",
      //   "Basic Person",
      "LEEP Report",
    ],
  },
  // {
  //   title: "Owner/Operator Reports",
  //   reports: [
  //       "Maintenance Reports"
  //   ],
  // },
  // {
  //   title: "D.A.D Reports",
  //   reports: [
  //       "Average D.A.D Processing Time",
  //       "Number Of Completed Requests By Recruiter",
  //   ],
  // },
  // {
  //   title: "System Reports",
  //   reports: ["User Login History"],
  // },
];

function ReportListPage() {
  return (
    <Container className="form-wrapper my-4">
      <div className="text-center mb-4">
        <h3>Reports</h3>
      </div>

      <Row>
        {reportCategories.map((category, idx) => (
          <Col md={6} lg={4} key={idx} className="mb-4">
            <Card>
              <Card.Body>
                <Card.Title>{category.title}</Card.Title>
                <ul className="list-unstyled mb-0">
                  {category.reports.map((report, i) => (
                    <li key={i}>
                      <Link
                        to={`/reports/${report
                          .replace(/\s+/g, "-")
                          .toLowerCase()}`}
                      >
                        {report}
                      </Link>
                    </li>
                  ))}
                </ul>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
}

export default ReportListPage;
